// istanbul ignore file
import { getV2RuntimeFromDll } from "@next-core/runtime";
import { pick } from "lodash";
export function authV2Factory() {
  const v2Kit = getV2RuntimeFromDll();
  if (v2Kit) {
    return Object.freeze(pick(v2Kit, ["authenticate", "getAuth", "isLoggedIn", "logout", "addPathToBlackList", "isBlockedPath", "isBlockedUrl", "isBlockedHref"]));
  }
}
//# sourceMappingURL=auth-v2.js.map